// @flow

import React from "react"
import { A, Middot } from "../layout"

export default () => (
    <footer className="page-footer grey lighten-5" style={{ marginTop: 0 }}>
        <div className="container">
            <div className="row">
                <div className="col s12">
                    <p className="footer-social">
                        <span className="footer-follow">
                            <A outbound href="https://github.com/simplyrets">
                                <span className="fa fa-github-square" />
                            </A>{" "}
                            <A outbound href="https://twitter.com/simplyrets">
                                <span className="fa fa-twitter-square" />
                            </A>{" "}
                            <A
                                outbound
                                href="https://wordpress.org/plugins/simply-rets/">
                                <span className="fa fa-wordpress" />
                            </A>
                        </span>
                        <span className="hide-on-small-only right">
                            <a href="mailto:support@simplyrets.com">
                                support@simplyrets.com
                            </a>
                        </span>
                    </p>
                </div>

                <div className="col l3 s12 footer-col">
                    <h5 className="grey-text text-darken-3">
                        About SimplyRETS
                    </h5>
                    <ul>
                        <li>
                            <a href="/">Homepage</a>
                        </li>
                        <li>
                            <a href="/blog/getting-set-up">Getting Started</a>
                        </li>
                        <li>
                            <a href="/#home-pricing">Plans & Pricing</a>
                        </li>
                        <li>
                            <a href="/faq">FAQ</a>
                        </li>
                        <li>
                            <a href="/blog">Blog</a>
                        </li>
                        <li>
                            <a href="/#home-contact">Contact Us</a>
                        </li>
                    </ul>
                </div>

                <div className="col l3 s12 footer-col">
                    <h5 className="grey-text text-darken-3">Solutions</h5>
                    <ul>
                        <li>
                            <a href="/services">Products and Services</a>
                        </li>
                        <li>
                            <a href="/idx-developer-api">Developer IDX API</a>
                        </li>
                        <li>
                            <a href="/wordpress-idx-plugin">
                                WordPress IDX Plugin
                            </a>
                        </li>
                        <li>
                            <a href="/services#geocoding">MLS Geocoding</a>
                        </li>
                        <li>
                            <a href="/idx-developer-api#openhouses-api">
                                Open Houses API
                            </a>
                        </li>
                        <li>
                            <a href="/services#analytics">Market Analytics</a>
                        </li>
                    </ul>
                </div>

                <div className="col l3 s12 footer-col">
                    <h5 className="grey-text text-darken-3">
                        Documentation & More
                    </h5>
                    <ul>
                        <li>
                            <A outbound href="https://docs.simplyrets.com">
                                Documentation
                            </A>
                        </li>
                        <li>
                            <A
                                outbound
                                href="https://docs.simplyrets.com/api/index.html">
                                Interactive API Docs
                            </A>
                        </li>
                        <li>
                            <A
                                outbound
                                href="https://github.com/SimplyRETS/examples">
                                Starter API examples
                            </A>
                        </li>
                        <li>
                            <A
                                outbound
                                href="https://wordpress-demo.simplyrets.com/">
                                WordPress IDX demo
                            </A>
                        </li>
                        <li>
                            <A
                                outbound
                                href="https://docs.simplyrets.com/simply-rets-client.html">
                                WordPress Style Guide
                            </A>
                        </li>
                        <li>
                            <A outbound href="https://github.com/simplyrets">
                                Open Source
                            </A>
                        </li>
                    </ul>
                </div>

                <div className="col l3 s12 footer-col">
                    <h5 className="grey-text text-darken-3">
                        Account and Support
                    </h5>
                    <ul>
                        <li>
                            <a href="/login">Login</a>
                        </li>
                        <li>
                            <a href="/signup">Create an account</a>
                        </li>
                        <li>
                            <a href="/blog/getting-set-up">
                                Making your first app
                            </a>
                        </li>
                        <li>
                            <a href="/#home-contact">Request Support</a>
                        </li>
                        <li>
                            <A outbound href="https://status.simplyrets.com/">
                                Service Status
                            </A>
                        </li>
                        <li>
                            <a href="/#home-contact">Contact Us</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div className="footer-copyright grey lighten-4 black-text">
            <div className="container">
                <div className="row">
                    <div className="col s12 m3">© 2015-2025 SimplyRETS</div>
                    <div className="col s12 m9 right-align">
                        <a href="/termsofservice">Terms of service</a>{" "}
                        <Middot />
                        <a href="/serviceagreement">
                            Service Level Agreement
                        </a>{" "}
                        <Middot />
                        <a href="/acceptableuse">Acceptable Use Policy</a>{" "}
                        <Middot />
                        <a href="/privacy">Privacy Policy</a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
)
